export default __webpack_public_path__ + "static/media/go-back.b4472cd0.svg";